import React, { useMemo, useRef, useState } from 'react';
import WalletCard from '../../../../../../components/WalletCard/WalletCard';
import HouseMoneyImage from '../../../../../../assets/icons/HouseMoneyWC.svg';
import failureIcon from '../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../assets/icons/succesIcon.svg';
import updateMemo from '../../../../../../assets/icons/updateMemo.svg';
import Info from '../../../../../../assets/icons/Info.svg';
import trashr from '../../../../../../assets/icons/trashr.svg';
import reverseIcon from '../../../../../../assets/icons/reverseTransactions.svg';
import useHouseMoney from '../../../../../../hooks/useHouseMoney';
import NoData from '../../../../../../components/NoData/NoData';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { AppliedTransactionSearch, HmNuban } from '../../../../../../types';
import HouseMoneySidesheet from '../../Sidesheets/HouseMoney/HouseMoneySidesheet';
import TransactionDetailsAlt from '../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import { useOutsideClick } from '../../../../../../helpers/utils';
import { LuMoreVertical } from 'react-icons/lu';
import ModalExecuteAction from '../../../../../../components/Modals/ModalExecuteAction';
import ModalTransactionSearch from '../../../../../../components/Modals/ModalTransactionSearch';
import InterestBreakdown from '../../../../../../components/InterestBreakdown/InterestBreakdown';
import { Loader } from '@piggytechng/component-library';
import SideSheet from '../../../../../../components/NewSideSheet';
import useRolePermissions from '../../../../../../hooks/useRolePermissions';

const index = () => {
  const { restrictActionByRole } = useRolePermissions({});

  const [showWalletBalance] = useState(true);
  const {
    setQuickActionPayload,
    houseMoneyTransactionsQ,
    houseMoneyDetails,
    handleHouseMoneyQuickAction,
    isLoadingHouseMoneyDetails,
    isLoading,
    searchHouseMoney,
    clearHouseMoneySearch,
    searchedHouseMoneyTransactions,
    isSearchingHouseMoney,
  } = useHouseMoney();
  const params = useParams();
  const [showHouseMoneySideSheet, setShowHouseMoneySideSheet] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<AppliedTransactionSearch | null>(null);
  const [activeHistoryTab, setActiveHistoryTab] = useState<'wallet' | 'interest'>('wallet');
  const [show, setShow] = useState(false);

  const houseMoneyTransactionsToShow = searchedHouseMoneyTransactions ?? houseMoneyTransactionsQ;

  const handleApplySearch = (_filter: string, value: string, display: string) => {
    setAppliedSearch({ filter: '', query: value, display });
    searchHouseMoney(value);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    clearHouseMoneySearch();
  };
  const [trDetails, setTrDetails] = useState({});
  const [showActionModal, setShowActionModal] = useState(false);

  const [showDropdown, setShowDropdown] = useState({
    index: -1,
    show: false,
  });

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  const balances = {
    houseMoney: 1000,
    targetSavings: 2000,
    targetSavingsTotalWallets: 5000,
    totalWalletKey: 'targetSavingsTotalWallets',
  };

  if (isLoadingHouseMoneyDetails) {
    <div className="page-loader">
      <Loader color="#0F60D6" />
    </div>;
  }

  const walletCardsData = useMemo(() => {
    const baseCards = [
      {
        title: 'House Money Balance:',
        balanceKey: houseMoneyDetails?.houseMoneyBalance ?? 0,
        cardId: 'hm-card',
        image: HouseMoneyImage,
        isActive: true,
        isOpenSideSheet: true,
        cardClick: () => setShowHouseMoneySideSheet(Object.keys(houseMoneyDetails).length ? true : false),
      },
      {
        title: 'Withdrawal Month',
        balanceKey: balances?.targetSavings,
        cardId: 'hm-card',
        totalWalletKey: 'targetSavingsTotalWallets',
        isBalance: false,
        isText: true,
        text: houseMoneyDetails?.withdrawalMonth ?? 'None',
        isOpenSideSheet: true,
        cardClick: () => setShowHouseMoneySideSheet(Object.keys(houseMoneyDetails).length ? true : false),
      },
    ];

    const nubanCards =
      Array.isArray(houseMoneyDetails?.nubans) && houseMoneyDetails.nubans.length > 0
        ? houseMoneyDetails.nubans
            .filter((account: { primaryNuban: boolean; deleted: boolean }) => !account.deleted && account.primaryNuban)
            .map((account: { bankName: string; accountNumber: string; primaryNuban: boolean }) => ({
              title: `Account Number - ${account.bankName}`,
              balanceKey: balances?.targetSavings,
              cardId: 'ts-card',
              totalWalletKey: 'targetSavingsTotalWallets',
              isBalance: false,
              isText: true,
              text: account.accountNumber,
              isAccCard: true,
              isDefault: account.primaryNuban,
            }))
        : [];

    return [...baseCards, ...nubanCards];
  }, [
    houseMoneyDetails?.houseMoneyBalance,
    houseMoneyDetails?.withdrawalMonth,
    houseMoneyDetails?.nubans,
    balances?.targetSavings,
  ]);

  const handleDeleteClick = (id: string) => {
    if (restrictActionByRole('housemoney', 'deleteHousemoneyAccountNumber')) return;

    setShowActionModal(true);
    setQuickActionPayload({
      accountNumber: id,
      action: 'delete_hm_nuban',
    });
  };

  const id = params.id as string;

  const handleShowTransactionsDetails = (data: any) => {
    setShow(true);
    setTrDetails(data);
  };

  const handleViewSingleTransaction = (i: number) => {
    const data = houseMoneyTransactionsQ ? houseMoneyTransactionsQ[i] : {};
    setTrDetails(data);
    setShow(true);
  };

  const dropdownArray = [
    {
      icon: updateMemo,
      text: 'Update memo',
      fn: () => setShowHouseMoneySideSheet(true),
      isActive: false,
    },
    {
      icon: Info,
      text: 'See more info',
      fn: (i?: number) => {
        if (typeof i === 'number') handleViewSingleTransaction(i);
      },
    },
    {
      icon: trashr,
      text: 'Delete transaction',
      fn: () => setShowHouseMoneySideSheet(true),
    },
    {
      icon: reverseIcon,
      text: 'Reverse transaction',
      fn: () => setShowHouseMoneySideSheet(true),
    },
  ];

  const onSuccessAction = () => {
    setShowActionModal(false);
  };

  const execution = {
    text: 'delete this account?',
    action: (password: string) => handleHouseMoneyQuickAction(onSuccessAction, undefined, undefined, password),
    actionColor: '',
    buttonText: 'Execute',
  };

  const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
    e.stopPropagation();
    if (i === showDropdown.index) {
      setShowDropdown({ ...showDropdown, show: false, index: -1 });
    } else {
      setShowDropdown({ ...showDropdown, show: true, index: i });
    }
  };

  return (
    <>
      <div>
        <div className="cards-container flex--2">
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              HMAccounts={houseMoneyDetails?.nubans.filter((account: HmNuban) => !account.deleted)}
              isAccCardAction={item.isAccCardAction}
              handleDeleteClick={handleDeleteClick}
            />
          ))}
        </div>
        <div className="wallets-details">
          <div className="history-tab-switch housemoney">
            <span
              className={`history-pill${activeHistoryTab === 'wallet' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('wallet')}
            >
              Wallet History
            </span>
            <span
              className={`history-pill${activeHistoryTab === 'interest' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('interest')}
            >
              Interest Breakdown
            </span>
          </div>
          {activeHistoryTab === 'wallet' && (
            <div className="customers-filter">
              <div className="input-field">
                <form action="" onSubmit={(e) => e.preventDefault()}>
                  <input
                    type="text"
                    readOnly
                    placeholder="Search by reference, amount, memo, date"
                    value={appliedSearch ? appliedSearch.display : ''}
                    onClick={() => setShowSearchModal(true)}
                  />
                </form>
              </div>
              <div className="query-filter" onClick={() => setShowSearchModal(true)}>
                <div>
                  <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                      stroke="#1E293B"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </div>
                <div>Search</div>
              </div>
              <div className="query-filter" onClick={handleResetSearch}>
                <div></div>
                <div>Reset</div>
              </div>
            </div>
          )}
        </div>
        {activeHistoryTab === 'interest' ? (
          <InterestBreakdown walletName="housemoney" />
        ) : houseMoneyTransactionsToShow?.length ? (
          <div className="table-container housemoney">
            <table className="table">
              <thead className="table_head">
                <tr>
                  <th className="icon">{''}</th>
                  <th className="date">Date</th>
                  <th className="amount">{`Amount (₦)`}</th>
                  <th className="">{`Balance (₦)`}</th>
                  <th className="memo">Memo</th>
                  <th className="transactionID">Transaction ID</th>
                </tr>
              </thead>

              <tbody className="table-body">
                {houseMoneyTransactionsToShow?.map((txn, i) => (
                  <tr key={txn.id} className="table-row" onClick={() => handleShowTransactionsDetails(txn)}>
                    <img src={txn.amount[0] === '+' ? successIcon : failureIcon} />
                    <td>{dayjs(txn.created_at).format('D MMM YYYY | h:mm A')}</td>
                    <td>{txn.amount}</td>
                    <td>{txn.balance}</td>
                    <td className="memo">{txn.memo}</td>
                    <td>{txn.id}</td>
                    {/* <img className="chevron-table" src={chevronTable} ref={actionRef} /> */}
                    <div className="dropdown-container" ref={actionRef}>
                      <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                        <LuMoreVertical color="#CBD5E1" size={25} />
                      </button>

                      {showDropdown.index === i && showDropdown.show && (
                        <div className="table-dropdown" ref={dropdownRef}>
                          <Dropdown data={dropdownArray} index={i} />
                        </div>
                      )}
                    </div>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <NoData message={'No transaction at the moment.'} />
        )}
      </div>

      <SideSheet active={showHouseMoneySideSheet} onClose={() => setShowHouseMoneySideSheet(false)}>
        <HouseMoneySidesheet userId={id} onClose={() => setShowHouseMoneySideSheet(false)} data={houseMoneyDetails} />
      </SideSheet>

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
      {/* <ModalAction modalIsOpen={showActionModal} setIsOpen={setShowActionModal} {...execution} /> */}
      <ModalExecuteAction
        modalIsOpen={showActionModal}
        setIsOpen={setShowActionModal}
        {...execution}
        isLoading={isLoading}
      />

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        hasCriteria={false}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={isSearchingHouseMoney}
        initialQuery={appliedSearch?.query}
      />
    </>
  );
};

export default index;
